import moment from 'moment';
import * as firestore from 'firebase/firestore';
import Timestamp = firestore.Timestamp;

export const DATE_DEFAULT_FORMAT = 'DD.MM.YYYY';

export class DateConverter {

    public static toMilliseconds(date: Date | Timestamp) {
        if (!!date) {
            if (date instanceof Date) {
                return date.getTime();
            } else if (date instanceof Timestamp) {
                return date.toDate().getTime();
            } else {
                return date;
            }
        }
        return date;
    }

    public static toString(date: Date | Timestamp | string, format = DATE_DEFAULT_FORMAT): any {
        if (!!date) {
            if (typeof date === 'string') {
                return date;
            }
            return moment(date instanceof Date ? date : date.toDate()).format(format);
        }
    }

    /**
     * Format milliseconds, date string or timestamp to date object
     * @param date Date in milliseconds, date string or timestamp
     * @param format Optional. Only needed if the date passed by params is a string and has a different format.
     */
    public static toDate(date: number | string | Timestamp | Date, format = DATE_DEFAULT_FORMAT) {
        if (date instanceof Timestamp) {
            return date.toDate();
        } else if (typeof date === 'number') {
            return new Date(date);
        } else if (typeof date === 'string') {
            return moment(date, format).toDate();
        } else {
            return date;
        }
    }

}
